import { render } from "./TaskTile.vue?vue&type=template&id=3aba8fe6&scoped=true"
import script from "./TaskTile.vue?vue&type=script&lang=js"
export * from "./TaskTile.vue?vue&type=script&lang=js"

import "./TaskTile.vue?vue&type=style&index=0&id=3aba8fe6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3aba8fe6"

export default script